import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { Spinner } from 'core/components/spinner';
import { Label } from 'core/components/label';

const useStyles = makeStyles({
  animation: {
    margin: '0 auto',
    paddingBottom: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  container: {
    margin: '0 auto',
    paddingTop: 40
  }
});

function BranchSpinner({ className }) {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={classNames(styles.animation, className)}>
        <Spinner size={128} />
      </div>
      <Label type="darkSmall">Processing the purchase...</Label>
    </div>
  );
}

BranchSpinner.propTypes = {
  className: PropTypes.string
};

BranchSpinner.defaultProps = {
  className: ''
};

export default BranchSpinner;
